import React, { useRef, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {getPrivileges} from '../../functions/Auth';
import DetailsCard from '../StationDetails/Intersection/DetailsCard';
import PublicFilesCard from './PublicFilesCard';
const NoDetails = props => {
    return (
      <>
        <div className="info-no-data-pn">
            <div className='empty-cnt-img'>
                <img src={require('../../assets/icons/empty_data_icon.svg')}  />                            
            </div>            
            <label className='title-no-data'>No traffic count data</label>
            <label className='title-no-data-more'>This station has no traffic count data added to it at this time. Check back later!</label>              
        </div>
        {props.stationData ?
          <>
            <label className='info-sub-title'>Details</label>            
            <DetailsCard stationData={props.stationData}/>
        </>:null}
        <PublicFilesCard stationData={props.stationData}/>
        {(getPrivileges().length !== 0 && props.showButton)?<Grid container>
          <Grid item xs={12} style={{textAlign: 'center',padding:'8px 0'}}>
            <Button className='btn-blue btn-view-all-details' variant="contained" onClick={props.handleOpenAllDetails}>View all details</Button>
          </Grid>            
        </Grid>:null}
      </>  
    )

}

export default NoDetails;